import { MainLayout } from "~/components";
import { useEffect } from "react";
import Grid from "@mui/material/Grid";
import { HeroPage } from "./HeroPage";
import { height } from "@mui/system";
import { makeStyles } from "@material-ui/core/styles";
import {
  max1,
  max2,
  rem,
  piotr,
  leon,
  linked,
  nang,
  chibuz,
  kyran, 
  teamsBG,
  filip
} from "~/assets";
import Typography from "@mui/material/Typography";
import Box from "@material-ui/core/Box";
import { Teamcard } from "../../components";
import { repeat } from "lodash";

const useStyles = makeStyles((theme) => ({
  root:{
    [theme.breakpoints.up("lg")]: {
      backgroundImage: `url(${teamsBG})`,
      backgroundSize: "contain",
      backgroundRepeat: "no-repeat",
    },
  }
}))
export const TeamSection = () => {
  const classes = useStyles();
  const data1 = [
    {
      img: <img src={max1} alt="rect"></img>,
      name: "Max Miskow",
      title: "Co-Founder & CEO",
      icon: <a href="https://www.linkedin.com/in/max-miskow/ "><img src={linked} alt="rect"></img></a>,
    },
    {
      img: <img src={piotr} alt="rect"></img>,
      name: "Piotr Oginski",
      title: "Co-Founder & COO",
      icon: <a href="https://www.linkedin.com/in/piotr-ogiński-ba5122208/ "><img src={linked} alt="rect"></img></a>,
    },
    {
      img: <img src={max2} alt="rect"></img>,
      name: "Jaroslaw Stadnicki",
      title: "CTO",
      icon: <a href="https://www.linkedin.com/in/jaroslawstadnicki/ "><img src={linked} alt="rect"></img></a>,
    },
  ];
  const data2 = [
    {
      img: <img src={rem} alt="rect"></img>,
      name: "Remigiusz  Kazmierczak",
      title: "Tech Lead & Full Stack Developer",
      icon: <a href="https://www.linkedin.com/in/remigiusz-kaźmierczak-271a81231/ "><img src={linked} alt="rect"></img></a>,
    },
    {
      img: <img src={leon} alt="rect"></img>,
      name: "Leon Thau",
      title: "Marketing Officer",
      icon: <a href="https://www.linkedin.com/in/leon-thau-2305a1212 "><img src={linked} alt="rect"></img></a>,
    },
  ];

  const data3 = [
    {
      img: <img src={nang} alt="rect"></img>,
      name: "Nang Nguyen",
      title: "Blockchain Advisor",
      icon: <a href="https://www.linkedin.com/in/nang-nguyen-the-019988a6/ "><img src={linked} alt="rect"></img></a>,
    },
    {
      img: <img src={chibuz} alt="rect"></img>,
      name: "Chibuzor Udokwu",
      title: "Blockchain Technical Advisor  ",
      icon: <a href="https://www.linkedin.com/in/chibuzor-udokwu-33870458/ "><img src={linked} alt="rect"></img></a>,
    },
    {
      img: <img src={kyran} alt="rect"></img>,
      name: "Kyran Parker",
      title: "Business Development Advisor ",
      icon: <a href="https://www.linkedin.com/in/kyranparker/"><img src={linked} alt="rect"></img></a>,
    },
    {
      img: <img src={filip} alt="rect"></img>,
      name: "Filip Zoledziowski",
      title: "Blockchain Advisor",
      icon: <a href="https://www.linkedin.com/in/filip-zoledziowski/"><img src={linked} alt="rect"></img></a>,
    }
  ];

  return (
    <Box maxWidth='1440px' width="90%" className={classes.root} marginTop={15} marginX={{ xs: 2, lg: 10, xl:0 }} id="team">
      <Box textAlign={{xs:"left", lg:"center"}}>
        <Typography variant="h5"
        style={{
          backgroundColor:"#F69501",
          backgroundImage: 'linear-gradient(268.99deg, #F69501 0.03%, #F1756E 100.53%)',
          WebkitTextFillColor:'transparent',
          backgroundClip:'text',
          WebkitBackgroundClip:'text'
        }}
        fontSize={{xs:'12px', md:'16px'}}
        lineHeight={{xs:'18px', md:'26px'}}
        letterSpacing='0.2rem'
        >THE TEAM</Typography>
        <Typography fontSize={{xs:'24px', lg: '40px'}} variant="h6">Meet our team</Typography>
      </Box>
      <Box marginY={5}>
        <Typography
          // marginY={10}
          textAlign={"center"}
          sx={{ color: "#fff", fontWeight: 600, letterSpacing: "0.2rem", opacity: "0.5", fontSize: "18px" }}
        >
          CORE TEAM
        </Typography>
        <Box
          display={"flex"}
          flexDirection={{ xs: "column", md: "column", lg: "row" }}
          justifyContent="space-evenly"
          alignItems="center"
        >
          {data1.map((item, index) => {
            return (
              <Box>
                <Teamcard
                  img={item.img}
                  name={item.name}
                  title={item.title}
                  icon={item.icon}
                />
              </Box>
            );
          })}
        </Box>
        <Box
          display={"flex"}
          flexDirection={{ xs: "column", md: "column", lg: "row" }}
          // marginTop={5}
          justifyContent="space-evenly"
          alignItems="center"
        >
          {data2.map((item, index) => {
            return (
              <Box>
                <Teamcard
                  img={item.img}
                  name={item.name}
                  title={item.title}
                  icon={item.icon}
                />
              </Box>
            );
          })}
        </Box>
      </Box>
      <Box>
        <Typography
          marginTop={10}
          textAlign={"center"}
          sx={{ color: "#fff", fontWeight: 600, letterSpacing: "0.2rem", opacity: "0.5", fontSize: "18px" }}
        >
          ADVISORS
        </Typography>
        <Box
          display={"flex"}
          flexDirection={{ xs: "column", md: "column", lg: "row" }}
          flexWrap={{lg:"wrap", xs:"no-wrap"}}
          justifyContent="space-evenly"
          alignItems="center"
        >
          {data3.map((item, index) => {
            return (
              <Box>
                <Teamcard
                  img={item.img}
                  name={item.name}
                  title={item.title}
                  icon={item.icon}
                />
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};
